import React from 'react';

export default function Tooltip({ children, content, className = "", position = "top" }) {
  // Gestion simple des positions (top par défaut)
  const positionClasses = {
    top: {
      container: "absolute -top-[42px] left-1/2 -translate-x-1/2",
      arrow: "absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-ink-950 border-r border-b border-white/10 rotate-45",
    },
    bottom: {
      container: "absolute top-[calc(100%+8px)] left-1/2 -translate-x-1/2",
      arrow: "absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-ink-950 border-l border-t border-white/10 rotate-45",
    }
  };

  const pos = positionClasses[position] || positionClasses.top;

  return (
    <div className={`relative flex items-center group/tooltip ${className}`}>
      {children}
      {content && (
        <div className={`${pos.container} opacity-0 group-hover/tooltip:opacity-100 transition-opacity duration-200 pointer-events-none z-50`}>
          <div className="bg-ink-950 text-white text-[11px] font-medium px-3 py-1.5 rounded-md shadow-hp-md whitespace-nowrap border border-white/10 flex items-center gap-1.5">
            {content}
            <div className={pos.arrow} />
          </div>
        </div>
      )}
    </div>
  );
}

